import { AnalyticsEvent } from '../models';

export class LogoutCompleteEvent implements AnalyticsEvent {
  name = 'LogoutCompleteEvent';
}
